import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "full-table" }
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_add_edit_node = _resolveComponent("add-edit-node")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("tbody", null, [
          _cache[1] || (_cache[1] = _createElementVNode("tr", null, [
            _createElementVNode("th", { colspan: "42" }, [
              _createElementVNode("div", { class: "table-filters" }, [
                _createElementVNode("div", null, "Edit Department, Type, and Process Owner")
              ])
            ])
          ], -1)),
          _cache[2] || (_cache[2] = _createElementVNode("tr", { class: "table-labels" }, [
            _createElementVNode("td", null, "Name"),
            _createElementVNode("td", null, "Type"),
            _createElementVNode("td", null, "Last Modified"),
            _createElementVNode("td", null, "Last Modified By"),
            _createElementVNode("td", null, "Process Owner"),
            _createElementVNode("td")
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: '/playbook/' + process.Slug
                }, {
                  default: _withCtx(() => [
                    (process.Mine)
                      ? (_openBlock(), _createBlock(_component_svg_icon, {
                          key: 0,
                          style: {"width":"18px","height":"18px","margin-bottom":"-3px"},
                          icon: "star"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(process.Name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$store.state.playbookNodeTypeMap[process.Type]), 1),
              _createElementVNode("td", null, _toDisplayString(process.LastModifiedString), 1),
              _createElementVNode("td", null, _toDisplayString(process.LastUpdatedBy), 1),
              _createElementVNode("td", null, _toDisplayString(process.ProcessOwnerNames), 1),
              (_ctx.$store.state.adminRolesCanEdit.includes(_ctx.$store.state.user.role))
                ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.editProcess(process, i)), ["prevent"])
                    }, "Edit", 8, _hoisted_3)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ], 2),
    (_ctx.showEditNode)
      ? (_openBlock(), _createBlock(_component_add_edit_node, {
          key: 0,
          node: _ctx.nodeToEdit,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeEditProcess()))
        }, null, 8, ["node"]))
      : _createCommentVNode("", true)
  ]))
}